import client from 'app/client'
import { ListResponse } from 'types';

export async function login(params: { email: string; password: string }) {
  return await client.post('/login', params)
}

export async function getUserPermissions(id:string) {
  return (
    await client.get(`/backoffice/acteurs/permissions-list?abpUserId=${id}`
     )
    )?.data
} 

export async function getCourtierInfo(id:string) {
  return (
      await client.get(`/backoffice/acteurs/courtier?courtierId=${id}`)
    )?.data
}

export async function fetchListAssureurs() : Promise<ListResponse<any>> {
  return (await client.get(`/backoffice/assureurs/all`))?.data
}

export async function fetchListProprietaireProduit() : Promise<ListResponse<any>> {
  return (await client.get(`/backoffice/proprieraires`))?.data
}
